module.exports = __webpack_public_path__ + "media/images/restaurant/areas/western_honshu_m-46d7876d17352685aa877a5c3bd2db4c.png";